import type { ComponentProps } from 'react';
import styled from 'styled-components';
import { _ } from '@splunk/ui-utils/i18n';
import { variables } from '@splunk/themes';
import Switch from '@splunk/react-ui/Switch';
import P from '@splunk/react-ui/Paragraph';
import type { LinkToEvent } from '@splunk/dashboard-types';
import type { Modal, returnFocus } from '../Modal';

export const StyledSwitch = styled(Switch)`
    float: left;
    align-items: start;
    margin-top: ${variables.spacingSmall};
`;

// To ensure a really long url doesn't force the modal to expand or scroll
export const StyledUrl = styled.span`
    word-break: break-word;
`;

export const redirectionStyle = {
    fontWeight: 500,
    marginBottom: 0,
};
export const StyledNote = styled(P)`
    font-size: 12px;
    max-width: 500px;
    margin: ${variables.spacingMedium} 0;
`;

export const TEXT = {
    TITLE: _('Redirecting away from Splunk'),
    INVALID_TITLE: _('Invalid URL'),
    CONTINUE: _('Continue'),
    CANCEL: _('Cancel'),
    CLOSE: _('Close'),
    ALLOW_AND_DONT_ASK: _("Don't show this again"),
    ALLOW_AND_DONT_ASK_NOTE: _(
        'Applies to your current session for this URL domain and parameters.'
    ),
    REDIRECTION: _('You are being redirected away from Splunk to:'),
    INVALID_REDIRECTION: _('You cannot redirect away from Splunk to:'),
    INVALID_NOTE: _(
        'The URL you clicked cannot open as it is invalid and might contain malicious code. Change the URL to a relative or absolute URL, such as /app/search/datasets or https://www.splunk.com.'
    ),
    NOTE: _(
        'Note that tokens embedded in a URL could contain sensitive information.'
    ),
};

export interface ProtectedUrlModalProps extends Partial<
    Omit<ComponentProps<typeof Modal>, 'open' | 'divider' | 'onRequestClose'>
> {
    event?: LinkToEvent['payload'];
    onRequestClose?: () => void;
    onAddUrlToAllowList?: (url: string) => void;
    returnFocus: returnFocus;
}
